import { dom } from '@fortawesome/fontawesome-svg-core'
  ; (async () => {
    const { default: moment } = await import('moment')
    const { default: Swiper } = await import('../../plugins/swiper/swiper')
    import('../../plugins/swiper/swiper.scss')

    Promise.all([
      import('../../plugins/semantic/form'),
      import('../../plugins/semantic/form.scss'),
      import('../guest-selector/guest-selector'),
      import('../guest-selector/guest-selector.scss'),
    ]).then(() => {
      Promise.all([
        import('../../scripts/dbs/dbs.semantic.form'),
        import('../../plugins/semantic/input.scss'),
        import('../../plugins/semantic/label.css'),
        import('../../plugins/semantic/transition.css'),
        import('../../plugins/semantic/transition.js'),
        import('../../plugins/semantic/icon.css'),
        import('../../plugins/semantic/modal.scss'),
        import('../../plugins/semantic/popup.css'),
        import('../../plugins/semantic/dropdown.scss'),
        import('../../plugins/semantic/dropdown'),
        import('../../plugins/semantic/modal'),
        import('../../plugins/semantic/dimmer.scss'),
        import('../../plugins/semantic/dimmer'),
        import('../../plugins/daterangepicker/daterangepicker'),
        import('../../plugins/daterangepicker/daterangepicker.scss'),
        import('../../scripts/dbs/dbs.utilities.geolocation'),
        import('../../scripts/dbs/dbs.utilities.querystring'),
        import('../../plugins/semantic/search'),
        import('../../plugins/semantic/search.scss'),
        import('../../plugins/semantic/api'),
        import(/* webpackMode: "eager" */ './accommodation-availability.scss'),
      ]).then(() => {
        $('.widget.accommodation-availability').each(function (i, el) {
          $(el).data('widget', new AccommodationAvailability(el, Swiper, moment))
          $(el).data('widget').init()
        })
      })
    })
  })()

function AccommodationAvailability(el, Swiper, moment) {
  const self = this
  self.el = $(el)
  self.propertyCode = self.el.attr('data-propertyCode')
  self.parkCutoffEndpoint = self.el.attr('data-search-top-park-room-cutoff')
  self.parkCutoffEndpointMethod = 'GET'
  self.getAccommodationEndpoint = self.el.attr('data-search-top-park-rooms')
  self.getAccommodationEndpointMethod = self.el.attr('data-method')
  self.getAccommodationAvailableDatesEndpoint = self.el.attr('data-search-top-park-rooms-availabledates')
  self.getAccommodationAvailableDatesEndpointMethod = self.el.attr('data-method')

  self.dateSelector = self.el.find('.filters .date-selector')
  self.sortByDropdown = self.el.find('.sort-container .ui.dropdown')

  self.arriveInput = self.el.find('.arrive.input')
  self.departInput = self.el.find('.depart.input')
  self.adultsInput = self.el.find('.adults.input')
  self.kidsInput = self.el.find('.kids.input')
  self.infantsInput = self.el.find('.infants.input')
  self.adultsShownValue = self.el.find('.adults.value')
  self.infantsShownValue = self.el.find('.infants.value')
  self.kidsShownValue = self.el.find('.kids.value')
  self.totalGuestsValue = self.el.find('.total-guests-value')
  self.totalGuestsInput = self.el.find('.total.guests.input')

  self.accommodationTypeInput = self.el.find('.accommodation-type.input')
  self.sortByInput = self.el.find('.sort-container input[type="hidden"]')
  self.maxSearchResults = self.el.find('.maxSearchResults.input')
  const sortFilterIcon = self.el.find('.sort-container div.icon')

  self.today = new Date()
  self.tomorrow = new Date(new Date().setDate(new Date().getDate() + 1))
  self.dayAfterTomorrow = new Date(new Date().setDate(new Date().getDate() + 2))
  self.maxDate = new moment().add(1, 'y').toDate()

  self.propertyItemTemplate = require('./property-item-template.hbs')
  self.parkItemTemplate = require('./park-item-template.hbs')
  self.messageInfoTemplate = require('./message-info-template.hbs')

  self.qs = new dbs.utilities.querystring()
  self.isMobile = $('body').hasClass('is-mobile-view')
  const resultsWrapper = self.el.find('.accommodation-list')

  function getInitialDateSelectorDates() {
    function getDayAfterDate(date) {
      return moment(new Date(new Date(date).setDate(new Date(date).getDate() + 1))).format('YYYY-MM-DD')
    }

    return new Promise((resolve) => {
      let arrive, depart
      let paramArrive = self.qs.getParameter('arrive')
      let paramDepart = self.qs.getParameter('depart')

      if (paramArrive) {
        arrive = paramArrive
        depart = paramDepart ?? getDayAfterDate(paramArrive)
      } else {
        $.ajax({
          url: self.parkCutoffEndpoint + `?code=${self.propertyCode}`,
          type: 'GET',
          dataType: 'json',
          async: false,
          contentType: 'application/json',
        })
          .done(function (isPastParkCutoff) {
            arrive = isPastParkCutoff ? self.tomorrow : self.today
            depart = isPastParkCutoff ? self.dayAfterTomorrow : self.tomorrow
          })
          .fail(function () {
            arrive = self.today
            depart = self.tomorrow
          })
      }

      const dates = {
        arrive: moment(arrive).format('YYYY-MM-DD'),
        depart: moment(depart).format('YYYY-MM-DD'),
      }

      resolve(dates)
    })
  }

  function getAvailableDates() {
    const params = new URLSearchParams(window.location.search)

    let data = {
      propertyCode: self.propertyCode,
      arrive: self.dateSelector.find('.arrive.input').val(),
      depart: self.dateSelector.find('.depart.input').val(),
      adults: params.get('adults') ?? 2,
      kids: params.get('kids') ?? 0,
      infants: params.get('infants') ?? 0,
      accommodationType: params.get('accommodationType') ?? '',
      sort: params.get('sort') ?? 'price_desc',
      roomCodes: [],
    }

    const dealCode = params.get('dealCode')
    if (dealCode) {
      data.dealCode = dealCode
    }
    return $.ajax({
      url: self.getAccommodationAvailableDatesEndpoint,
      type: self.getAccommodationAvailableDatesEndpointMethod,
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
  }

  async function initDateSelectorCalendar() {
    const initialDates = await getInitialDateSelectorDates()

    setDateSelectorDates(initialDates.arrive, initialDates.depart)

    let availableDates = undefined

    if ($(el).attr('data-brand') === 'gdayparks') {
      availableDates = await getAvailableDates()

      // Format dates to 'YYYY-MM-DD'
      availableDates = availableDates?.Dates?.map((date) => date.substring(0, 10))
    }

    // See: https://www.daterangepicker.com/#options
    self.dateSelector.daterangepicker(
      {
        autoApply: true,
        startDate: initialDates.arrive,
        endDate: initialDates.depart,
        minDate: self.today,
        maxDate: self.maxDate,
        parentEl: self.dateSelector.parent(),
        locale: {
          format: 'YYYY-MM-DD',
        },
        isInvalidDate: function (date) {
          // NOTE `return true` will mark the date as invalid.
          if (availableDates === undefined) return false

          // If there ares no available dates, and we are showing a message, then `return false` to unlock the calendar
          if (availableDates.length == 0 && self.el.find('#accommodation-availability-message')) return false

          return !availableDates.includes(moment(date).format('YYYY-MM-DD'))
        },
      },
      function (startDate, endDate) {
        setDateSelectorDates(startDate, endDate)
        self.search()
      },
    )

    self.dateSelector.on('show.daterangepicker hide.daterangepicker', function (event, picker) {
      if (event.type === 'show') {
        picker.element.addClass('open')
      } else {
        picker.element.removeClass('open')
      }
    })
  }

  function initGuestSelectorFilter() {
    // NOTE dates selector is handled in another function
    window.dbs.globalEvents.subscribe('guestselector:updated', function () {
      self.search()
    })
  }

  function initParkTypesFilter() {
    self.el.find('.park-types a').click(function (event) {
      event.preventDefault()
      let parkType = $(this).attr('data-type')
      setParkTypeFilter(parkType)
      self.search()
    })

    // Set initial value
    let accommodationTypeParam = self.qs.getParameter('accommodationType')
    if (accommodationTypeParam) {
      setParkTypeFilter(accommodationTypeParam.toLowerCase())
    }
  }

  function initSortByFilter() {
    // Init dropdown so we can set initial value
    self.sortByDropdown.dropdown({ placeholder: false })

    // Set initial value
    let sortParam = self.qs.getParameter('sort')
    if (sortParam) {
      setSortByFilter(sortParam, true)
    }

    // Now initial value is set, re-init dropdown with `onChange` callback
    self.sortByDropdown.dropdown({
      placeholder: false,
      onChange: function () {
        self.search()
        $('.dropdown-text > div').html(self.sortByDropdown.dropdown('get text'))
      },
    })
  }

  function initFilters() {
    initDateSelectorCalendar()
    initGuestSelectorFilter()
    initParkTypesFilter()
    initSortByFilter()
  }

  function getNearbyParksPricesData(propertyCodes) {
    if (!propertyCodes) return

    let data = {
      propertyCodes: propertyCodes || [],
      from: self.filters.arrive,
      to: self.filters.depart,
      adults: self.filters.adults,
      kids: self.filters.kids,
      infants: self.filters.infants,
      sort: self.el.find('.sort-container input[type="hidden"]').val(),
    }

    return $.ajax({
      url: self.el.find('.results-nearby').attr('data-prices'),
      type: self.el.find('.results-nearby').attr('data-method'),
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
  }

  async function getNearbyParksData() {
    let result = {}
    try {
      result = await $.ajax({
        url: self.el.find('.results-nearby').attr('data-endpoint'),
        type: self.el.find('.results-nearby').attr('data-method'),
        data: JSON.stringify(self.filters),
        dataType: 'json',
        contentType: 'application/json',
      })
      return result
    } catch (err) {
      console.error(err.status, err.statusText)
      return result
    }
  }

  async function renderNearbyParks(data) {
    const nearbyParksContainer = self.el.find('.results-nearby')

    // Check if we want to show/hide nearby parks
    if (!data.ShowNearbyParks) {
      nearbyParksContainer.html('')
      return
    }

    // Render the 'Nearby Parks' list items
    const propertiesData = await getNearbyParksData()
    if (propertiesData.Properties.length === 0) {
      // Show the message text
      let template = document.createElement('template')
      let messageText = propertiesData.Message || 'We could not find any parks nearby based on your search. Please modify your search and try again.'
      template.innerHTML = self.messageInfoTemplate({ messageBody: messageText })
      nearbyParksContainer.html('').append(template.content)
      return
    }

    const propertyCodes = propertiesData.Properties.reduce(function (propertyCodes, property) {
      return [...propertyCodes, property.PropertyCode]
    }, [])

    const pricesData = await getNearbyParksPricesData(propertyCodes)

    // NOTE The 'Prices' data is correctly order by the 'sort by' filter. As such, we loop over the 'Prices' data
    // and merge in the additional 'Properties' data, matching against the 'PropertyCode'. Additionally, we create
    // new data to handle plural/non-plural labels. This consolidated data is then used to render the results in one go.
    const nearbyParks = pricesData.Prices.reduce(function (nearbyParksData, pricesData) {
      let propertyData = propertiesData.Properties.filter(function (propertyData) {
        if (propertyData.PropertyCode === pricesData.PropertyCode) {
          return propertyData
        }
      })

      let pricesNewData = {
        GuestsLabel: pricesData.Guests > 1 ? 'guests' : 'guest',
        NightsLabel: pricesData.Nights > 1 ? 'nights' : 'night',
      }

      let nearbyParkData = {
        ...propertyData[0],
        Prices: {
          ...pricesData,
          ...pricesNewData,
        },
      }

      return [...nearbyParksData, nearbyParkData]
    }, [])

    const nearbyParksFragment = new DocumentFragment()
    for (let i = 0; i < nearbyParks.length; i++) {
      const nearbyPark = nearbyParks[i]
      const template = document.createElement('template')
      template.innerHTML = self.parkItemTemplate(nearbyPark)
      nearbyParksFragment.append(template.content)
    }
    nearbyParksContainer.html('').append(nearbyParksFragment).show()

    // Add pages' params to links in 'Nearby Parks' list items
    const pageParams = window.location.href.split('?')[1]
    if (pageParams) {
      let links = ['.results-nearby .result .actions a', '.results-nearby .result .top .title'].join(',')
      self.el.find(links).each(function (i, link) {
        $(link).attr('href', $(link).attr('href') + `?${pageParams}`)
      })
    }

    let parksSummaries = nearbyParksContainer.find('.summary')
    const calculateSummariesReadMore = function (summaries) {
      summaries.each((i, el) => {
        const summary = $(el)

        // If user has expanded, do nothing.
        if (summary.hasClass('has-expanded')) {
          return
        }

        // Remove attr, to remove CSS styles effecting heights, and allow us to measure heights accurately.
        summary.removeAttr('aria-expanded')

        // Check if summary is considered already 'expanded'.
        const preview = summary.find('.js-preview')
        const content = summary.find('.js-content')
        if (preview.outerHeight() >= content.outerHeight()) {
          summary.attr('aria-expanded', true)
          return
        }

        summary.attr('aria-expanded', false)

        // Handle 'read more' click event
        const readMoreLink = summary.find('.js-read-more')
        readMoreLink.on('click', (event) => {
          event.preventDefault();
          summary.attr('aria-expanded', true)
          summary.addClass('has-expanded')
        })
      })
    }

    calculateSummariesReadMore(parksSummaries)
    window.addEventListener("resize", () => {
      // NOTE: summary content is hidden below 1224px.
      if (window.innerWidth <= 1224) return;
      calculateSummariesReadMore(parksSummaries)
    });

    // Init image sliders
    nearbyParksContainer.find('.result .images').each(function (i, el) {
      const resultImages = $(el)
      if (resultImages.attr('data-images-count') > 1) {
        const swiperEl = resultImages.find('.swiper')
        swiperEl.addClass('as-slider')
        dom.i2svg({ node: el }) // render slider navigation arrows
        new Swiper(swiperEl, {
          loop: true,
          spaceBetween: 0,
          navigation: {
            nextEl: resultImages.find('.swiper-button-next'),
            prevEl: resultImages.find('.swiper-button-prev'),
          },
          pagination: {
            el: resultImages.find('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
        })
      }
    })
  }

  function renderAvailableProperties(data) {
    // Update 'available' summary text
    self.el.find('.available .summary').html(data.Summary)

    // Show the 'available' list header
    if (data.AvailableProperties.length > 0) {
      self.el.find('.results-container .available .top-header').show()
    }
    var dealcodevariable = checkDealCode();

    const availableResultsContainer = self.el.find('.available .results')
    const pageParams = window.location.href.split('?')[1]

    // Render the 'available' properties list items
    const availablePropertiesFragment = new DocumentFragment()
    for (let i = 0; i < data.AvailableProperties.length; i++) {
      const property = data.AvailableProperties[i]

      // Clean up numbers
      property.TotalPrice = Math.trunc(property.TotalPrice)
      property.DealPrice = property.DealPrice && Number(property.DealPrice).toFixed(2)
      property.MembersPrice = property.MembersPrice && Number(property.MembersPrice).toFixed(2)
      property.Discount = Math.trunc(property.TotalPrice - property.DealPrice)
      property.AccommodationFromPrice = Math.trunc(property.AccommodationFromPrice)
      property.GdayFlutterEnabled = window.FlutterParityEnabled;
      let actionButtons = [];
      property.ActionButtons.forEach((button) => {
        if (button.Label == "Enquire") {
          button.isEnquire = true;
        } else {
          button.isEnquire = false;
        }
        actionButtons.push(button);
      })
      property.ActionButtons = actionButtons;

      // Append params
      // CW-8299 Assign index (starting from 1) to each items' links, to know position of item in results list, when data pushed to GA.
      const indexParam = `index=${i + 1}`
      property.Index = i + 1;
      for (let j = 0; j < property.ActionButtons.length; j++) {
        const button = property.ActionButtons[j]
        if (button.Path === property.RoomUrl) {
          button.Path = `${button.Path}?${indexParam}&${pageParams}`
        }
      }
      property.RoomUrl = `${property.RoomUrl}?${indexParam}&${pageParams}`
      
      //Particular deal accommodation filters via pulling in room code and checking it against the data attributes under data-particular-id-list
      if (dealcodevariable != null && dealcodevariable != ""){
        var element = document.querySelector(`[data-promocode="${dealcodevariable}"]`);
  
        if (element) {
          const particularIdList = element.getAttribute('data-particular-id-list');
          const idArray = particularIdList.split(',').map(item => item.trim());
          const isMatchFound = idArray.some(id => id === property.RoomCode);
          if (isMatchFound){
            property.DealApplied = true;
          }
        }        
      } 
      // Render HTML
      const template = document.createElement('template')
      template.innerHTML = self.propertyItemTemplate(property)
      availablePropertiesFragment.append(template.content)
    }
    availableResultsContainer.html('').append(availablePropertiesFragment)

    // Init image slider for each result item
    availableResultsContainer.find('.images').each(function (i, el) {
      const resultImages = $(el)
      if (resultImages.attr('data-images-count') > 1) {
        const swiperEl = resultImages.find('.swiper')
        swiperEl.addClass('as-slider')
        dom.i2svg({ node: el }) // render slider navigation arrows
        new Swiper(swiperEl, {
          loop: true,
          spaceBetween: 0,
          navigation: {
            nextEl: resultImages.find('.swiper-button-next'),
            prevEl: resultImages.find('.swiper-button-prev'),
          },
          pagination: {
            el: resultImages.find('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
        })
      }
    })
  }

  function renderNotAvailableProperties(data) {
    // Hide/show the 'not available' list
    // TODO: Count how many available properties there are, set index to that, then add index here
    let currentIndex = data.AvailableProperties.length +1;
    if (data.NotAvailableProperties.length === 0) {
      return self.el.find('.results-container .unavailable').hide()
    } else {
      self.el.find('.results-container .unavailable').show()
    }

    const unavailableResultsContainer = self.el.find('.unavailable .results')
    //const pageParams = window.location.href.split('?')[1]
    const pageParamsList = new URLSearchParams(window.location.href.split('?')[1]);
    pageParamsList.delete('index');
    const pageParams = pageParamsList.toString();

    // Render the 'not available' properties list items
    const notAvailablePropertiesFragment = new DocumentFragment()
    for (let i = 0; i < data.NotAvailableProperties.length; i++) {
      const property = data.NotAvailableProperties[i]

      // Clean up numbers
      property.TotalPrice = Math.trunc(property.TotalPrice)
      property.DealPrice = property.DealPrice && Number(property.DealPrice).toFixed(2)
      property.MembersPrice = property.MembersPrice && Number(property.MembersPrice).toFixed(2)
      property.Discount = Math.trunc(property.TotalPrice - property.DealPrice)
      property.AccommodationFromPrice = Math.trunc(property.AccommodationFromPrice)
      property.Index = currentIndex;
      property.RoomUrl = `${property.RoomUrl}?${pageParams}&index=${property.Index}`
      property.GdayFlutterEnabled = window.FlutterParityEnabled;


      let actionButtons = [];
      property.ActionButtons.forEach((button) => {
        if (button.Label.trim() == "Enquire") {
          button.isEnquire = true;
        } else {
          button.isEnquire = false;
        }
        button.Path = `${button.Path}?${pageParams}&index=${currentIndex}`
        actionButtons.push(button);
      })

      currentIndex +=1;
      property.ActionButtons = actionButtons;
      // var dealcodevariable = checkDealCode();

      // Render HTML
      const template = document.createElement('template')
      // TODO: This is weird
      if (property.IsDiscoveryParks) {
        template.innerHTML = self.propertyItemTemplate(property)
      } else {
        // Don't apply deal for not available properties
        property.DealApplied = false
        template.innerHTML = self.propertyItemTemplate(property)
      }
      notAvailablePropertiesFragment.append(template.content)
    }
    unavailableResultsContainer.html('').append(notAvailablePropertiesFragment)

    // Init image slider for each result item
    unavailableResultsContainer.find('.images').each(function (i, el) {
      const resultImages = $(el)
      if (resultImages.attr('data-images-count') > 1) {
        const swiperEl = resultImages.find('.swiper')
        swiperEl.addClass('as-slider')
        dom.i2svg({ node: el }) // render slider navigation arrows
        new Swiper(swiperEl, {
          loop: true,
          spaceBetween: 0,
          navigation: {
            nextEl: resultImages.find('.swiper-button-next'),
            prevEl: resultImages.find('.swiper-button-prev'),
          },
          pagination: {
            el: resultImages.find('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
          },
        })
      }
    })
  }
  function checkDealCode(){
    // Use the current page's URL
    const url = window.location.href;
    // Create a URL object
    const urlObj = new URL(url);
    // Extract the 'dealCode' value
    const dealCode = urlObj.searchParams.get("dealCode");
    // Log or use the dealCode value as needed
    if (process.env.NODE_ENV === 'development') {
      console.log("the deal code is as follows: ", dealCode); // Output: the dealCode value from the current URL
    }
    return dealCode;
  }

  function setDateSelectorDates(dateFrom, dateTo) {
    self.dateSelector
      .find('.date-range-picker')
      .removeClass('empty')
      .text(moment(dateFrom).format('DD MMM') + ' – ' + moment(dateTo).format('DD MMM'))

    self.arriveInput.val(moment(dateFrom).format('YYYY-MM-DD'))
    self.departInput.val(moment(dateTo).format('YYYY-MM-DD'))
  }

  function setParkTypeFilter(parkType) {
    const button = self.el.find(`.park-types a[data-type=${parkType}]`)

    // Toggle off or between filter types
    if ($(button).hasClass('active')) {
      $(button).removeClass('active')
      self.el.find('.accommodation-type.input').val('')
    } else {
      $(button).addClass('active').siblings().removeClass('active')
      self.el.find('.accommodation-type.input').val(parkType)
    }
  }

  function setSortByFilter(sortBy) {
    if (process.env.NODE_ENV === 'development') {
      console.log(sortBy)
    }
    self.sortByDropdown.dropdown('set selected', sortBy)
  }

  function getFilterValues() {
    let filters = {
      propertyCode: self.propertyCode,
      arrive: self.arriveInput.val(),
      depart: self.departInput.val(),
      adults: self.adultsInput.val(),
      kids: self.kidsInput.val(),
      infants: self.infantsInput.val(),
      accommodationType: self.accommodationTypeInput.val(),
      sort: self.sortByInput.val(),
      maxSearchResults: self.qs.getParameter('maxSearchResults') ?? self.maxSearchResults.val(),
      index: self.qs.getParameter('index'),

    }


    // NOTE Only add `dealCode` property if we have a value.
    const dealCode = self.qs.getParameter('dealCode')
    if (dealCode) {
      filters.dealCode = dealCode
    }

    var urlForParam = new URL(window.location.href);
    urlForParam.searchParams.forEach((val, key)=>{
      // Add a Property
      if (!filters.hasOwnProperty(key))
      {
        Object.defineProperty(filters, key, { value: self.qs.getParameter(key), writable: true, configurable: true, enumerable: true});
      }
    });

    return filters
  }

  function getPropertiesDataByRoomCode(roomCode) {
    if (!roomCode) return

    const data = {
      roomCodes: [roomCode],
      propertyCode: self.propertyCode,
      arrive: self.filters.arrive,
      depart: self.filters.depart,
      adults: self.filters.adults,
      kids: self.filters.kids,
      infants: self.filters.infants,
      accommodationType: self.filters.accommodationType,
    }

    return $.ajax({
      url: $(el).attr('data-search-top-park-room'),
      type: $(el).attr('data-method'),
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
  }

  /**
   * Checks to see if the element bottom falls out of view, and scrolls into view if true. Determines what layout
   * is displaying (stacked, or two column) using `matchMedia` then compares the element bottom against the
   * relevant parent scrolling element bottom (window or results wrapper) and scrolling to ensure the element is
   * fully in view.
   * @param el - jQuery DOM element
   */
  function scrollElBottomIntoView(el) {
    const elBottom = el[0].getBoundingClientRect().bottom

    // If two column layout, else stacked layout
    const mediaQuery = window.matchMedia('(min-width: 768px)')
    if (mediaQuery.matches) {
      const overflowDistance = elBottom - resultsWrapper[0].getBoundingClientRect().bottom
      if (overflowDistance > 0) {
        resultsWrapper[0].scrollBy({
          top: overflowDistance,
          behavior: 'smooth',
        })
      }
    } else {
      const overflowDistance = elBottom - window.innerHeight
      if (overflowDistance > 0) {
        window.scrollBy({
          top: overflowDistance,
          behavior: 'smooth',
        })
      }
    }
  }

  function initPropertyCalendar({ triggerEl, parentEl, roomCode, datesData }) {
    let availableDates = datesData.availableDates[roomCode]

    triggerEl.daterangepicker(
      {
        autoApply: true,
        opens: 'right',
        startDate: moment(self.filters.arrive, 'YYYY-MM-DD'),
        endDate: moment(self.filters.depart, 'YYYY-MM-DD'),
        minDate: self.today,
        maxDate: self.maxDate,
        parentEl: parentEl,
        locale: {
          format: 'YYYY-MM-DD',
        },
        isInvalidDate: function (date) {
          return !availableDates.includes(moment(date).format('YYYY-MM-DD'))
        },
        isCustomDate: function (date) {
          let theDate = moment(date).format('YYYY-MM-DD')
          let availableDateIndex = availableDates.indexOf(theDate)

          if (availableDateIndex === -1) {
            return ['not-available']
          }

          let availableDatePrice = datesData.prices[roomCode][availableDateIndex]
          return ['calendar-price-tooltip', `price_${availableDatePrice}`]
        },
      },
      function (startDate, endDate) {
        setDateSelectorDates(startDate, endDate)
        self.dateSelector.data('daterangepicker').setStartDate(moment(startDate).format('YYYY-MM-DD'));
        self.dateSelector.data('daterangepicker').setEndDate(moment(endDate).format('YYYY-MM-DD'));

        // For 'not available' result items, if user selects available dates using the calendar to pick dates available for this item,
        // we perform a new search and this 'not available' result item will be moved into the 'available' results. As such, we want
        // to pass the room code to focus (scroll to) this item when the new search results are returned.
        self.search({
          //focusRoomCode: parentEl.parent().hasClass('results-unavailable') && roomCode,
          focusRoomCode: roomCode //unvailable AND available items will be scrolled into view
        })
      },
    )

    triggerEl.on('show.daterangepicker hide.daterangepicker', function (event, picker) {
      if (event.type === 'show') {
        picker.element.addClass('open')
        scrollElBottomIntoView(picker.container)
      } else {
        picker.element.removeClass('open')
      }
    })
  }

  self.pushState = function (filters) {
    // Filter out empty values, considering falsely values
    let stateFilters = Object.fromEntries(Object.entries(filters).filter(([, value]) => value === 0 || !!value))

    // Update URL params with new filter values, but do not reload the page.
    history.replaceState({ filters: stateFilters }, '', window.location.pathname + '?' + $.param(stateFilters))
  }

  self.search = function ({ focusRoomCode } = {}) {
    self.el.addClass('loading')

    // Emit 'disable' of controls (used by 'guest-selector' widget)
    window.dbs.globalEvents.emit('disableControls')

    self.filters = getFilterValues()

    self.pushState(self.filters)

    const data = {
      ...self.filters,
      // roomCodes: [] // I don't think this is required
    }

    // send filters to ajax
    $.ajax({
      url: self.getAccommodationEndpoint,
      type: self.getAccommodationEndpointMethod,
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        // CW-8299 [view_item_list] Accommodation listing
        ; (function () {
          if (data.ParkDataLayer) {
            const dataLayerAsJson = JSON.parse(data.ParkDataLayer)
            // TODO verify data layer object
            // Remove not required fields
            delete dataLayerAsJson.park_name;
            delete dataLayerAsJson.park_id;
            delete dataLayerAsJson.region;
            delete dataLayerAsJson.state;
            delete dataLayerAsJson.amenities;
            if (process.env.NODE_ENV === 'development') {
              console.log(`CW-8299 event ${dataLayerAsJson.event}`, JSON.stringify(dataLayerAsJson, null, 2))
            }
            window.dataLayer = window.dataLayer || [] // Create a data layer
            dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object
            dataLayer.push(dataLayerAsJson)
          }
        })()

        // Handle 'deal code' removal
        let shouldRemoveDeal = data[Object.keys(data).find((key) => key.match(/^removedeal$/i))]
        //if (shouldRemoveDeal && self.qs.getParameter('dealcode')) {
          //window.location.href = self.qs.removeParameter('dealcode', window.location.href)
        //}
        if (shouldRemoveDeal && self.qs.getParameter('dealcode')) {
          // Don't reload, just remove from URL parameters, then re-search
          self.filters.dealCode = '';
          self.pushState(self.filters);
          self.search();
          return;
        }

        // Handle 'dates' state
        if (self.filters.arrive !== data.From || self.filters.depart !== data.To) {
          setDateSelectorDates(data.From, data.To)
          self.dateSelector.data('daterangepicker').setStartDate(moment(data.From).format('YYYY-MM-DD'));
          self.dateSelector.data('daterangepicker').setEndDate(moment(data.To).format('YYYY-MM-DD'));

          // Push new state
          self.filters = getFilterValues()
          self.pushState(self.filters)
        }

        // Emit 'available deals' data
        window.dbs.globalEvents.emit('deals_updated', { AvailableDeals: data.AvailableDeals }, true)

        // Clear previous messages text
        self.el.find('#accommodation-availability-message').remove()

        // If we have a 'message' we do not have any 'available' properties to show
        // thus we will update the UI to show 'nearby parks' in place.
        AccommodationAvailabilityMessageHandler.handleMessage(data, self);

        // Ensure 'results container' is showing
        self.el.find('.results-container').show()

        renderAvailableProperties(data)
        renderNotAvailableProperties(data)
        renderNearbyParks(data)

        // Init date range picker for each 'available' property
        const availablePropertiesDatesAndPrices = data.AvailableProperties.reduce(
          (acc, property) => {
            // Create two separate arrays for available date, and available date price where their index matches.
            // So, the price matching for date `availableDates[42]` will be `availableDatesPrices[42]`.
            let availableDates = []
            let prices = []

            property.Dates.map((entry) => {
              availableDates.push(entry.Date.substring(0, 10)) // Format dates to 'YYYY-MM-DD'
              prices.push(entry.Price)
            })

            // Assign each array to the key of the same 'room code'
            acc['availableDates'][property.RoomCode] = availableDates
            acc['prices'][property.RoomCode] = prices

            return acc
          },
          {
            availableDates: {},
            prices: {},
          },
        )

        self.el.find('.results-container .available .item .calendar-trigger').each(function (i, el) {
          const calendarTrigger = $(el)
          const resultItem = calendarTrigger.parents('.item')
          const roomCode = resultItem.data('roomcode')

          initPropertyCalendar({
            datesData: availablePropertiesDatesAndPrices,
            triggerEl: calendarTrigger,
            parentEl: resultItem,
            roomCode: roomCode,
          })
        })

        // Init date range picker for each 'not available' property
        const notAvailablePropertiesDatesAndPrices = {
          availableDates: {},
          prices: {},
        }

        self.el.find('.results-container .unavailable .item .calendar-trigger').click(async function (event) {
          const calendarTrigger = $(event.currentTarget)
          const resultItem = calendarTrigger.parents('.item')
          const roomCode = resultItem.data('roomcode')

          // Get data by 'roomCode' of item
          // TODO fix recursive call if 'roomCode' fails to match after ajax call (if no data, if endpoint fails)
          if (!notAvailablePropertiesDatesAndPrices['availableDates'][roomCode]) {
            event.preventDefault()

            // TODO move loading from whole widget to just the result item or result item calendar trigger?
            self.el.addClass('loading')

            const data = await getPropertiesDataByRoomCode(roomCode)
            data.AvailableProperties.reduce((acc, property) => {
              // Create two separate arrays for available date, and available date price where their index matches.
              // So, the price matching for date `availableDates[42]` will be `availableDatesPrices[42]`.
              let availableDates = []
              let prices = []

              property.Dates.map((entry) => {
                availableDates.push(entry.Date.substring(0, 10)) // Format dates to 'YYYY-MM-DD'
                prices.push(entry.Price)
              })

              // Assign each array to the key of the same 'room code'
              acc['availableDates'][property.RoomCode] = availableDates
              acc['prices'][property.RoomCode] = prices

              return acc
            }, notAvailablePropertiesDatesAndPrices)

            self.el.removeClass('loading')
          }

          if (!calendarTrigger.data('daterangepicker')) {
            event.preventDefault()

            initPropertyCalendar({
              datesData: notAvailablePropertiesDatesAndPrices,
              triggerEl: calendarTrigger,
              parentEl: resultItem,
              roomCode: roomCode,
            })

            calendarTrigger.click()
          }
        })

        // Handle tooltips
        if ($(window).width() > 1024) {
          self.el.find('.ui.tooltip.sleeps').popup({
            on: 'hover',
            position: 'top left',
          })
          self.el.find('.ui.tooltip.tile').popup({
            on: 'hover',
            position: 'top left',
          })
        }

        // Set images, icons and tooltip text in result items
        self.fireIcon = data.FireRestrictedIcon
        self.petIcon = data.PetRestrictedIcon
        self.fireIconText = data.FireRestrictedIconText
        self.petIconText = data.PetRestrictedIconText
        self.rewardLogo = data.RewardLogo

        self.el.find('.fire-icon').attr('src', self.fireIcon)
        self.el.find('.fire-icon').parents('.icon').attr('data-tooltip', self.fireIconText)

        self.el.find('.pet-icon').attr('src', self.petIcon)
        self.el.find('.pet-icon').parents('.icon').attr('data-tooltip', self.petIconText)

        self.el.find('.reward-logo img').attr('src', self.rewardLogo)

        // Emit 'enable' of controls (used by 'guest-selector' widget)
        window.dbs.globalEvents.emit('enableControls')
        if (focusRoomCode)
        {
          let resultItem = $('.item[data-roomcode="' + focusRoomCode +'"]')
          let scrollTop = resultItem.position().top;
          if (resultItem)
          {
            if (self.isMobile) {
              window.scrollTo({ top: scrollTop, behavior: 'smooth' });
            }
            else {
              resultsWrapper[0].scrollTo({ top: scrollTop, behavior: 'smooth' });
            }       
          }
        }
      })
      .fail(function () {
        // TODO decide what happens on fail
      })
      .always(function () {
        // See: https://fontawesome.com/v5/docs/apis/javascript/methods#dom-i2svg-params
        dom.i2svg()

        self.el.removeClass('loading')
      })
  }

  self.init = async function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('AccommodationAvailability init', self)
    }
    self.el.css('opacity', 1)

    // NOTE 'calendar-price-tooltip' CSS class can be found in result items calendar popup.
    $('body').on('click mouseenter', '.calendar-price-tooltip', function () {
      const classes = $(this).attr('class').split(' ')

      for (let i = 0; i < classes.length; i++) {
        const class1 = classes[i]
        if (class1.indexOf('price') !== -1) {
          $(this).attr('data-tooltip', '$' + class1.split('_')[1])
        }
      }
    })



    window.dbs.globalEvents.subscribe('update_k13_accommodation_widget', (data) => {
      if (!data.hasOwnProperty('bookingContext')) {
        if (process.env.NODE_ENV === 'development') {
          console.log("No booking context found when updating accommodation widget")
        }
        return;
      }
      let newFilters = {};
      newFilters.arrive = moment(data.bookingContext.checkIn).format('YYYY-MM-DD');
      newFilters.depart = moment(data.bookingContext.checkOut).format('YYYY-MM-DD');
      newFilters.adults = parseInt(data?.bookingContext.adults) ?? 2;
      newFilters.kids = parseInt(data?.bookingContext.children) ?? 0;
      newFilters.infants = parseInt(data.bookingContext.infants) ?? 0;
      if(data.bookingContext.hasOwnProperty('appliedDealId')) {
        if(data.bookingContext.appliedDealId != "") {
          newFilters.dealCode = data.bookingContext.appliedDealId;

        }
      }
      // Check if anything has actually changed to avoid unneccessary API calls
      if (newFilters.arrive != self.filters.arrive ||
        newFilters.depart != self.filters.depart ||
        newFilters.adults != self.filters.adults ||
        newFilters.kids != self.filters.kids ||
        newFilters.infants != self.filters.infants
      ) {

        if (newFilters.arrive != self.filters.arrive || newFilters.depart != self.filters.depart) {
          setDateSelectorDates(newFilters.arrive, newFilters.depart)
          //update the selected dates in calendar
          self.dateSelector.data('daterangepicker').setStartDate(moment(newFilters.arrive).format('YYYY-MM-DD'));
          self.dateSelector.data('daterangepicker').setEndDate(moment(newFilters.depart).format('YYYY-MM-DD'));
        }
        let emitGuestUpdate = false;
        if (newFilters.adults != self.filters.adults) {
          //self.adultsInput.val(newFilters.adults);
          emitGuestUpdate = true;
        }
        if (newFilters.kids != self.filters.kids) {
          //self.kidsInput.val(newFilters.kids);
          emitGuestUpdate = true;
        }
        if (newFilters.infants != self.filters.infants) {
          //self.infantsInput.val(newFilters.infants);
          emitGuestUpdate = true;
        }


        // update total guests if guests amount has changed
        self.filters = newFilters;
        self.pushState(self.filters)
        if (emitGuestUpdate) {
          window.dbs.globalEvents.emit('search_popstate',{ filters: self.filters })
        }
        self.search();
      }
    })

    await initFilters()
    self.search()
  }

  sortFilterIcon.click(function () {
    $('.sort-container div.dropdown').click()
  })
}



const parksUnavailability = 'We could not find availability at your preferred park based on your search. Please modify your search and try again or you could consider these parks that are nearby.';
const ExceededBookingCutOffTime = 'ExceededBookingCutOffTime';
const BelowMinimunLengthOfStay = 'BelowMinimunLengthOfStay';


var AccommodationAvailabilityMessageHandler = 
{
  handleMessage: function(data, self){
    if (data.Message && data.Message.length) {
      //hacky fix to allow for unique message handling. The api wasn't producing an error identifier
      if (data.Message == parksUnavailability || data.UnavailableReasonType === ExceededBookingCutOffTime || data.UnavailableReasonType === BelowMinimunLengthOfStay) {
          AccommodationAvailabilityMessageHandler.showNearByParks(self);
        }
        // Show the message text
        const template = document.createElement('template')
        template.innerHTML = self.messageInfoTemplate({
          id: "accommodation-availability-message",
          messageBody: data.Message
        })
        self.el
          .find('.message-container')
          .append(template.content)
      } else {
          AccommodationAvailabilityMessageHandler.showAvailableParks(self);
      }
  },
  showAvailableParks: function(self){
    self.el.find('.availability-line .available').show();
    self.el.find('.availability-line .nearby-parks').hide();
  },
  showNearByParks: function(self){
    self.el.find('.availability-line .available').hide();
    self.el.find('.availability-line .nearby-parks').show();
  }
};
